import React, { Component } from 'react';
import PropTypes from 'prop-types';

const AgencySubIdHOC = (C) => {
  class AgencySubIdCont extends Component {
    static show() {
      /* return props.order.agency.showSubId; */
      return null;
    }

    constructor() {
      super();
      this.onChange = this.onChange.bind(this);
      this.validate = this.validate.bind(this);
    }

    onChange(name, value) {
      this.props.actions.updateAgencySubId(value);
    }

    validate(value) {
      return this.props.validatorFactory()
        .then(factory => factory.getAgencySubIdValidator(this.props.order))
        .then(validator => validator(value))
        .then(() => true,
          () => true);
    }

    render() {
      return AgencySubIdCont.show(this.props) ? (
<C
  agencySubId={this.props.order.agency.subId}
  error={this.props.errors.agency.subId}
  onChange={this.onChange}
  validate={this.validate}
/>
      ): null;
    }
  }

  AgencySubIdCont.PropTypes = {
    order:PropTypes.object.isRequired,
    errors:PropTypes.object.isRequired,
    actions:PropTypes.object.isRequired,
    validatorFactory:PropTypes.func.isRequired,
  };

  return AgencySubIdCont;
};

export default AgencySubIdHOC;
